export const pad2 = (value: number): string => String(value).padStart(2, "0");

export const toDateKey = (year: number, month: number, day: number): string =>
  `${year}-${pad2(month)}-${pad2(day)}`;

export const todayKey = (): string => {
  const now = new Date();
  return toDateKey(now.getFullYear(), now.getMonth() + 1, now.getDate());
};

export const currentTime = (): string => {
  const now = new Date();
  return `${pad2(now.getHours())}:${pad2(now.getMinutes())}`;
};

export const formatChineseDate = (date: string): string => {
  const [year, month, day] = date.split("-").map(Number);
  return `${year}年${month}月${day}日`;
};

export const daysInMonth = (year: number, month: number): number =>
  new Date(year, month, 0).getDate();

export const firstWeekday = (year: number, month: number): number =>
  new Date(year, month - 1, 1).getDay();

export const isValidDateKey = (value: string): boolean => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split("-").map(Number);
  return month >= 1 && month <= 12 && day >= 1 && day <= daysInMonth(year, month);
};
